import { createSelector, createSlice } from '@reduxjs/toolkit'
import { apiCallBegan } from '../actions/api'

const initialState = {
    genderTypes: { data: [], totalCount: 0 },
    loading: false,
    error: null,
    refreshing: false,
}

const genderTypeSlice = createSlice({
    name: 'genderTypes',
    initialState,
    reducers: {
        refreshRequested: (state, action) => {
            state.loading = true
            state.refreshing = true
            state.error = null
        },
        apiRequested: (state, action) => {
            state.loading = true
            state.error = null
        },
        apiRequestedFailed: (state, action) => {
            state.error = action.payload
            state.loading = false
            state.refreshing = false
        },
        getGenderTypes: (state, action) => {
            state.genderTypes = action.payload
            state.loading = false
            state.refreshing = false
        },
    },
})

const selectItems = (state) => state.data
const selectItemId = (state, itemId) => itemId
const selectItemById = createSelector([selectItems, selectItemId], (items, itemId) => {
    if (items) {
        const index = items.findIndex((item) => item.id === itemId)
        if (index >= 0) return { ...items[index] }
    }
    return {}
})
export { selectItemById }

export const { refreshRequested, apiRequested, apiRequestedFailed, getGenderTypes } = genderTypeSlice.actions
export default genderTypeSlice.reducer

export const getGenderTypeList = (filter, refresh = false) => {
    let url = `/api/Setting/genderType/list`
    return apiCallBegan({
        url: url,
        method: 'post',
        data: filter,
        onStart: refresh ? refreshRequested.type : apiRequested.type,
        onSuccess: getGenderTypes.type,
        onError: apiRequestedFailed.type,
    })
}
